const TOKEN_ID = 'token';
const CODE_ID = 'code';
const UM_URL_ID = 'userManagerUrl';
const CLIENT_ID = 'clientId';
const API_VERSION_ID = 'apiVersion';

export default {
  // setters
  setToken: (token) => window.localStorage.setItem(TOKEN_ID, token),
  setCode: (code) => window.localStorage.setItem(CODE_ID, code),
  setUMUrl: (url) => window.localStorage.setItem(UM_URL_ID, url),
  setClientId: (clientId) => window.localStorage.setItem(CLIENT_ID, clientId),
  setAPIVersion: (version) => window.localStorage.setItem(API_VERSION_ID, version),
  // getters
  getToken: () => window.localStorage.getItem(TOKEN_ID) || null,
  getCode: () => window.localStorage.getItem(CODE_ID) || null,
  getUMUrl: () => window.localStorage.getItem(UM_URL_ID) || null,
  getClientId: () => window.localStorage.getItem(CLIENT_ID) || null,
  getAPIVersion: () => window.localStorage.getItem(API_VERSION_ID) || null,
  // removers
  removeToken: () => window.localStorage.removeItem(TOKEN_ID),
  removeCode: () => window.localStorage.removeItem(CODE_ID),
};
